import { ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { AnimateFadeIn, ErrorMessage, HintMessage, InputErrorWrapper } from './styles';

const ANIMATION_TIMEOUT = 200;

type InputErrorType = {
  error?: string | null;
  apiError?: string | null;
  hint?: ReactNode;
};

export const InputError = ({ error, apiError, hint }: InputErrorType) => {
  const nodeRef = useRef(null);
  const hasApiError = !error && !!apiError;
  const hasAnyError = !!error || !!apiError;
  const hasHint = !!hint && !hasAnyError;
  const showContent = hasAnyError || hasHint;

  return (
    <InputErrorWrapper>
      <CSSTransition in={showContent} nodeRef={nodeRef} classNames='fade' timeout={ANIMATION_TIMEOUT} unmountOnExit>
        <AnimateFadeIn ref={nodeRef}>
          {hasHint && <HintMessage>{hint}</HintMessage>}
          {!!error && <ErrorMessage>{error}</ErrorMessage>}
          {hasApiError && <ErrorMessage>{apiError}</ErrorMessage>}
        </AnimateFadeIn>
      </CSSTransition>
    </InputErrorWrapper>
  );
};
